import { render, staticRenderFns } from "./integralRuleFees.vue?vue&type=template&id=6dc8f3a9&scoped=true"
import script from "./integralRuleFees.vue?vue&type=script&lang=js"
export * from "./integralRuleFees.vue?vue&type=script&lang=js"
import style0 from "./integralRuleFees.vue?vue&type=style&index=0&id=6dc8f3a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc8f3a9",
  null
  
)

export default component.exports